/* eslint-disable no-plusplus */
// eslint-disable-next-line import/no-unresolved
const quickviewSlider = require('../components/slider');
const baseUtils = require('./baseUtils');
const { imageZoom } = require('./components/imageZoom');
const constants = require('../constants');
const scrollAnimate = require('../components/scrollAnimate');
const utils = require('../utils');

function getPDPselectorQuantity(el) {
    return el.parents('.ctabar-product').length
        ? el.parents('.ctabar-product').find('.quantity-detail')
        : el.parents('.prices-add-to-cart-actions').find('.quantity-detail');
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    if (window.outerWidth > constants.viewport_bootstrap.md) {
        return $el && $('.set-items').length
            ? $($el).closest('.product-detail:not(.product-detail-set)').find('.quantity-detail')
            : $('.quantity-detail');
    }

    return $el && $('.set-items').length
        ? $($el).closest('.product-detail:not(.product-detail-set)').find('.quantity-detail')
        : getPDPselectorQuantity($($el));
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
baseUtils.getQuantitySelected = $el => getQuantitySelector($el).val();

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    let pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el)
            .closest('.modal-content')
            .find('.product-quickview')
            .attr('data-pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el)
            .closest('.product-detail:not(.product-detail-set)')
            .find('.product-id')
            .text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').attr('data-pid');
    }

    return pid;
}

function updateAddToCartButton() {
    const countPdpAttributes = $('.pdp-info-wrapper .attribute-wrapper').length;
    const countPdpAttributesSelected = $('.pdp-info-wrapper .attribute-wrapper .selected').length;
    const pdpButtons = $('.cart-and-ipay .add-to-cart, .trigger-add-to-cart, .show-stock');

    if (((countPdpAttributes === countPdpAttributesSelected)
            && (countPdpAttributes !== 0 && countPdpAttributesSelected !== 0))
        || $('.options-select').length
    ) {
        pdpButtons.removeClass('disabled');
        pdpButtons.attr('disabled', false);
    }
}

function updateAddToCartButtonSet() {
    const countPdpAttributes = $('.set-item .attribute-wrapper').length;
    const countPdpAttributesSelected = $('.set-item .attribute-wrapper .selected').length;
    const pdpSetButtons = $('.product-set-detail .cart-and-ipay .add-to-cart-global, .ctabar-product .add-to-cart-global');
    const pdpGoToSetButtons = $('.go-to-first-option');

    if (countPdpAttributes === countPdpAttributesSelected) {
        pdpSetButtons.removeClass('disabled d-none');
        pdpSetButtons.attr('disabled', false);
        pdpGoToSetButtons.addClass('d-none');
    } else {
        pdpSetButtons.addClass('disabled d-none');
        pdpSetButtons.attr('disabled', true);
        pdpGoToSetButtons.removeClass('d-none');
    }
}

// Event rewrite to control the add to cart button
const addToCart = () => {
    updateAddToCartButton();

    $(document.body).on('click', '.add-to-cart-grouped:not(.disabled)', (e) => {
        const thisTarget = $(e.currentTarget);
        const buttonsGrouped = $('.add-to-cart-grouped');
        $('.quantity-select .quantity').val(parseInt(thisTarget.parents('.add-to-cart-grouped-wrapper').find('.fake-quantity-input').text(), 10));
        buttonsGrouped.addClass('disabled');
        setTimeout(() => {
            const buttonAddToCart = $('.prices-add-to-cart-actions .add-to-cart');
            buttonAddToCart.trigger('click');
            buttonsGrouped.removeClass('disabled');
        }, 1000);
    });

    // eslint-disable-next-line func-names
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        const pid = getPidValue($(this));
        const addToCartUrl = baseUtils.methods.getAddToCartUrl();

        let pidsObj;
        let setPids;

        updateAddToCartButton();
        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            // eslint-disable-next-line func-names
            $('.product-detail:not(.product-detail-set)').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    const pidItem = $(this).find('.product-id').text();
                    if (pidItem) {
                        setPids.push({
                            pid: $(this)
                                .find('.product-id')
                                .text(),
                            qty: $(this)
                                .find('.quantity')
                                .val(),
                            options: baseUtils.methods.getOptions($(this)),
                        });
                    }
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        let $productContainer = $(this).closest('.product-detail:not(.product-detail-set)');
        if (!$productContainer.length) {
            $productContainer = $(this)
                .closest('.quick-view-dialog')
                .find('.product-detail:not(.product-detail-set)');
        }

        const form = {
            pid,
            pidsObj,
            childProducts: baseUtils.methods.getChildProducts(),
            quantity: getQuantitySelector($(this)).val(),
        };

        if (!$('.bundle-item').length) {
            form.options = baseUtils.methods.getOptions($productContainer.find('.pdp-info-wrapper'));
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success(data) {
                    baseUtils.methods.handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $.spinner().stop();
                    baseUtils.miniCartReportingUrl(data.reportingURL);
                },
                error() {
                    $.spinner().stop();
                },
            });
        }
    });
};

const descriptionBlock = () => {
    const docBody = $(document.body);
    docBody.on('click', '.show-more-less-description div', (e) => {
        const thisTarget = $(e.currentTarget);
        const descBlock = thisTarget.parents('.description-block').find('.block-description');

        if (descBlock.length) {
            thisTarget.parents('.show-more-less-description').toggleClass('open');
            descBlock.toggleClass('open');
        }
    });
};

const manageSwatchValuesClass = (attrValue, itemVariation,
    isOutOfStockProdNotAvailable, stockValue, siteLastItemsConfig) => {
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();

    if ((!attrValue.selectable && !attrValue.isoutOfstock && itemVariation.parents('.attribute-wrapper').index('.attribute-wrapper') !== 0)
    || isOutOfStockProdNotAvailable) {
        itemVariation.addClass('unselectable');
    } else if (attrValue.selectable && attrValue.isoutOfstock && siteAvailableOutOfstock === 'true') {
        itemVariation.addClass('outofstock icon-email-line');
    } else if (stockValue !== 'undefined'
                && !attrValue.isoutOfstock
                && stockValue <= siteLastItemsConfig) {
        itemVariation.addClass('lastItems info-icon');

        if (!itemVariation.find('.message-last-items').length) {
            const lastItemsMessageTooltip = $('#lastItemsMessageTooltip').val();
            const lastItemsDiv = `<div class="message-last-items tooltip">${lastItemsMessageTooltip}</div><span class="circle-red"></span>
            <div class="message-last-items-cta">${lastItemsMessageTooltip}</div>`;

            itemVariation.append(lastItemsDiv);
        }
    }
};

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValues(attr, $productContainer, msgs) {
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();
    const siteLastItemsConfig = parseInt($('#siteLastItemsConfig').val(), 10);

    attr.values.forEach((attrValue) => {
        const $attrValue = $productContainer.find(
            `[data-attr="${attr.id}"] [data-attr-value="${attrValue.value}"]`,
        );

        const $swatchButton = $attrValue.parent();
        const isOutOfStockProdNotAvailable = siteAvailableOutOfstock === 'false' && attrValue.isoutOfstock;
        const stockValue = attrValue.stock !== null ? attrValue.stock[$attrValue.attr('data-attr-value')] : 'undefined';

        $swatchButton.attr('data-url', attrValue.url);
        $swatchButton.attr('href', attrValue.url);

        $attrValue.attr('data-url', attrValue.url);
        $attrValue.attr('href', attrValue.url);

        if ($attrValue.parents('.attribute-wrapper').index('.attribute-wrapper') !== 0) {
            // Disable if not selectable
            $attrValue.removeClass('outofstock icon-email-line d-none selected lastItems unselectable');
        }

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        manageSwatchValuesClass(attrValue, $attrValue, isOutOfStockProdNotAvailable,
            stockValue, siteLastItemsConfig);

        if (!$('#quickViewModal').length) {
            const value = $attrValue.attr('data-attr-value');
            const elemt = $productContainer.parent().closest('.product-tile');
            const elemWithAttr = elemt.find(`a[data-attr-value='${value}']`);

            if (attrValue.selectable) {
                elemt.find(elemWithAttr).addClass('gridSwatch');
                elemt.find(elemWithAttr).attr('data-attr-value', value);
            } else {
                elemt.find(elemWithAttr).removeClass('gridSwatch');
                elemt.find(elemWithAttr).attr('data-attr-value', '');
            }
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    const $attr = `[data-attr="${attr.id}"]`;
    const $defaultOption = $productContainer.find(`${$attr} .select-${attr.id} option:first`);
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();
    const siteLastItemsConfig = parseInt($('#siteLastItemsConfig').val(), 10);

    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach((attrValue) => {
        const $attrValue = $productContainer.find(
            `${$attr} [data-attr-value="${attrValue.value}"]`,
        );
        $attrValue.attr('value', attrValue.url);

        if (!$('#quickViewModal').length) {
            const value = $attrValue.attr('data-attr-value');
            const isOutOfStockProdNotAvailable = siteAvailableOutOfstock === 'false' && attrValue.isoutOfstock;
            const itemVariation = $productContainer.find(`a[data-attr-value='${value}']`);
            const stockValue = attrValue.stock !== null ? attrValue.stock[value] : 'undefined';

            itemVariation.removeClass('outofstock icon-email-line d-none selected lastItems unselectable');

            manageSwatchValuesClass(attrValue, itemVariation, isOutOfStockProdNotAvailable,
                stockValue, siteLastItemsConfig);

            if (attrValue.selected) {
                $productContainer.find(`a[data-attr-value='${value}']`).addClass('selected');
            }
        }
    });
}

/**
 * Res the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttrs(attrs, $productContainer, msgs) {
    const swatchablesToCheck = $productContainer
        .find('.attribute-wrapper a.swatchable').parents('.attribute-pdp');
    // Array: Get the current swhatchables attr of some product container. ['color']
    const attrsWithSwatches = baseUtils.methods.getSwhatchables(swatchablesToCheck);

    attrs.forEach((attr) => {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

function dataLayerUpdateAfterHandleVariants(response, $productContainer) {
    $($productContainer).trigger('seo:updateProductVariant', response.dataLayer.mainProduct.product);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 */
function createCarousel(imagesLarge, imagesMedium, imagesSmall, $productContainer) {
    const { prev, next } = utils.getSliderLabels();
    const carousel = $productContainer.find('#product-gallery');
    const carouselSlick = carousel.hasClass('carousel-inner');
    const isModalGallery = carousel.parents('.modal').length;
    const carouselThumb = carousel.parents('.primary-images').find('.product-gallery-thumb');
    const carouselThumbVisible = carousel.parents('.primary-images').find('.product-gallery-thumb:visible').length;
    const carouselThumbParentWrapper = carousel.parents('.set-items');
    const zoomCarousel = $productContainer.find('.zoomCarousel .gallery-slider');

    carousel.addClass('hide');
    if (carouselSlick || isModalGallery || (window.outerWidth < constants.viewport_bootstrap.lg && $('.primary-images .carousel-inner').length <= 0 && !carousel.hasClass('carousel-mobile-disabled'))) {
        carousel.slick('destroy');

        if (carouselThumb.length && carouselThumbParentWrapper.length <= 0 && carouselThumbVisible && !$('#Cart-Show').length && !$('#Wishlist-Show').length) {
            carouselThumb.slick('destroy');
            carouselThumb.html('');
            carouselThumb.find('.carousel-item:not(.video)').remove();
        }
    }
    carousel.html('');
    carousel.find('.carousel-item:not(.video)').remove();

    if (zoomCarousel.length) {
        if (zoomCarousel.hasClass('slick-initialized')) {
            zoomCarousel.slick('destroy');
        }
        zoomCarousel.html('');
    }

    if (imagesMedium.length === 1) {
        carousel.addClass('pb-0');
    }

    const zoomLensEnabled = carousel.hasClass('zoom-lens') ? 'zoom-lens-enabled' : '';
    const ctaProductBar = $('.ctabar-product');
    const noSlickClass = carouselSlick || isModalGallery ? '' : ' col-12 col-lg-6 ';

    for (let i = 0; i < imagesMedium.length; i++) {
        if (carousel && !carousel.hasClass('carousel-mobile-disabled')) {
            $(`<div class="carousel-item image-zoom ${noSlickClass} ${zoomLensEnabled}" style="background-image: url('${imagesLarge[i].url}');"><img src="${imagesMedium[i].url}" data-src="${imagesMedium[i].url}" data-thumb="${imagesSmall[i].url}" class="d-block img-fluid" alt="${imagesLarge[i].alt}"  title="${imagesLarge[i].title}" itemprop="image" /></div>`).appendTo(carousel);
        } else if (carousel && carousel.hasClass('carousel-mobile-disabled')) {
            // else for Alvaro moreno project, remove when image sliding with slick slider is fluid
            $(`<div class="carousel-item image-zoom pb-1 ${zoomLensEnabled} ${i === 0 || i === 3 ? 'col-12 col-lg-6 pr-1 pl-1' : 'col-6'}
                ${i % 2 === 0 && i !== 0 && i < 3 ? 'pr-1' : ''} ${i % 2 !== 0 && i !== 0 && i < 3 ? 'pl-1' : ''}
                ${i % 2 === 0 && i !== 0 && i > 3 ? 'pl-1' : ''} ${i % 2 !== 0 && i !== 0 && i > 3 ? 'pr-1' : ''}" 
                style="background-image: url('${imagesLarge[i].url}');"><img src="${imagesMedium[i].url}" data-src="${imagesMedium[i].url}" data-thumb="${imagesSmall[i].url}" class="d-block img-fluid" alt="${imagesLarge[i].alt}"  title="${imagesLarge[i].title}" itemprop="image" /></div>`).appendTo(carousel);
        }

        if (carouselThumb.length && carouselThumbParentWrapper.length <= 0) {
            $(`<div class="carousel-item ${noSlickClass}"><img src="${imagesMedium[i].url}" data-src="${imagesMedium[i].url}" data-thumb="${imagesSmall[i].url}" class="d-block img-fluid" alt="${imagesLarge[i].alt}"  title="${imagesLarge[i].title}" itemprop="image" /></div>`).appendTo(carouselThumb);
        }

        if (zoomCarousel.length) {
            $(`<div class="carousel-item"><img src="${imagesLarge[i].url}" data-src="${imagesLarge[i].url}" data-thumb="${imagesSmall[i].url}" class="d-block img-fluid" alt="${imagesLarge[i].alt}" title="${imagesLarge[i].title}" itemprop="image" /></div>`).appendTo(zoomCarousel);
        }

        if (i === 0 && ctaProductBar.length && carouselThumbParentWrapper.length <= 0) {
            ctaProductBar.find('.product-image').attr('src', imagesLarge[i].url);
        }
    }

    if (carouselSlick || isModalGallery) {
        quickviewSlider.methods.useCustomizableSlick(carousel, true, `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`, 1, {
                dots: true,
                responsive: [
                    {
                        breakpoint: constants.viewport_bootstrap.md,
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });
    }

    if (window.outerWidth < constants.viewport_bootstrap.lg) {
        if ($('.primary-images .carousel-inner').length <= 0
        && !carousel.hasClass('carousel-mobile-disabled')) {
            quickviewSlider.methods.useCustomizableSlick('.primary-images .gallery-slider', false, '', '', 1, {});
        }

        if ($('.set-items').length <= 0) {
            scrollAnimate(carousel.parents('.product-detail'), 100);
        }
    }

    if (zoomCarousel.length) {
        quickviewSlider.methods.useCustomizableSlick(
            zoomCarousel,
            true,
            `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`,
            1,
            {},
        );
    }

    carousel.removeClass('hide');
    imageZoom(constants);
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    let availabilityValue = '';
    const availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = `<li><div>${response.resources.info_selectforstock}</div></li>`;
    } else {
        availabilityMessages.forEach((message) => {
            availabilityValue += `<li><div>${message}</div></li>`;
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer,
        message: availabilityValue,
        resources: response.resources,
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    let html = '';

    attributes.forEach((attributeGroup) => {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach((attribute) => {
                html += `<div class="attribute-values">${attribute.label}: ${
                    attribute.value
                }</div>`;
            });
        }
    });

    return html;
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    const isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    const currentSwatchImg = $('#product-gallery img').eq(0).attr('data-src');

    let isVariant;

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent('.bonus-product-item')
                .attr('data-pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .attr('data-ready-to-order', response.product.readyToOrder);
        }

        if (response.dataLayer) {
            dataLayerUpdateAfterHandleVariants(response, $productContainer);
        }
    }

    const isSwatchable = $('.pdp-info-wrapper .attribute-pdp.active .attributes-pdp-wrapper-img').length
        || $('.ctabar-product .attribute-pdp.active .attributes-pdp-wrapper-img').length
        || $('.row-product-info .colors-product-carousel .attributes-pdp-wrapper-img');
    if (currentSwatchImg !== response.product.images.large[0].url && isSwatchable) {
        // Update primary images
        const primaryImageUrlsLarge = response.product.images.large;
        const primaryImageUrlsMedium = response.product.images.medium;
        const primaryImageUrlsSmall = response.product.images.small;
        createCarousel(
            primaryImageUrlsLarge,
            primaryImageUrlsMedium,
            primaryImageUrlsSmall,
            $productContainer,
        );
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        const $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        const $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer,
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer,
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));

    const componentProduct = $('#out-of-stock-modal').find('input[name=productID]');
    componentProduct.val(response.product.id);

    if (response.outOfStockInformation.isOutOfStockHtml) {
        $productContainer.find('.prices-add-to-cart-actions > .row')
            .empty()
            .append(response.outOfStockInformation.isOutOfStockHtml);
        if (response.outOfStockInformation.isOutOfStock) {
            const currentModalOutOfStockImg = $('#out-of-stock-modal').find('.image-container > img');
            const currentModalOutOfStockTitle = $('#out-of-stock-modal').find('.nameproduct > span');

            if (currentModalOutOfStockImg.attr('src') !== response.product.images.large[0].url) {
                currentModalOutOfStockImg.attr('src', response.product.images.large[0].url);
                currentModalOutOfStockImg.attr('data-src', response.product.images.large[0].url);
                currentModalOutOfStockImg.attr('alt', response.product.images.large[0].alt);
                currentModalOutOfStockImg.attr('title', response.product.images.large[0].title);
            }

            if (currentModalOutOfStockTitle.text() !== response.product.productName) {
                currentModalOutOfStockTitle.text(response.product.productName);
            }
            // eslint-disable-next-line global-require
            const outOfStock = require('./outOfStock');
            outOfStock.showOutOfStock();
        }
    }

    // Update Flash Sales
    const flashSalesComponent = $('.flash-sales');
    if (flashSalesComponent.length) {
        const flashSalesInformation = response.product && response.product.flashSales
            && response.product.flashSales.renderedTemplate
            ? response.product.flashSales.renderedTemplate : null;
        if (flashSalesInformation) {
            flashSalesComponent.html('').append(flashSalesInformation);
            // eslint-disable-next-line global-require, import/no-unresolved, import/extensions
            const flashSales = require('./components/flashSales');
            flashSales.showTimer();
        } else {
            flashSalesComponent.html('');
        }
    }
}

function ctaBarCheckSelectedOptions() {
    const productAttrOptions = $('.attribute-options');
    if (productAttrOptions.length) {
        const productAttrSelectedOptions = productAttrOptions.find('.selected');
        if (productAttrSelectedOptions.length) {
            productAttrSelectedOptions.each((index, node) => {
                const attrSelected = $(node);
                const attrSelectedLabel = attrSelected.attr('data-attr-display-value');
                const parentWrapper = attrSelected.parents('.attribute-wrapper');
                parentWrapper.find('.attribute-selected-label').text(attrSelectedLabel);

                if (attrSelected.hasClass('swatchable') && attrSelected.find('.swatch-circle').length) {
                    const attrSelectedHtml = $(node).html();
                    if (parentWrapper.find('.attribute-selected .swatch-circle').length <= 0) {
                        parentWrapper.find('.attribute-selected').prepend(attrSelectedHtml);
                    } else {
                        parentWrapper.find('.attribute-selected .swatch-circle').replaceWith(attrSelectedHtml);
                    }
                }
            });
        }
    }
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml
 * from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
    ctaBarCheckSelectedOptions();
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        const optionsHtml = quantities.map((quantity) => {
            const selected = quantity.selected ? ' selected ' : '';
            return `<option value="${quantity.value}"  data-url="${quantity.url}"${
                selected}>${quantity.value}</option>`;
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Checks if selected option has lastItems class and update attribute label with selected value
 */
const checkSelectedOption = () => {
    const swatchableSelected = $('.row-product-info .attribute-pdp .swatchable.selected');
    swatchableSelected.each((index, node) => {
        const nodeSelected = $(node);
        const attributeLabel = nodeSelected.parents('.attribute-pdp').find('> label');
        if (nodeSelected.length) {
            const attributeValue = nodeSelected.find('.tooltip:not(.message-last-items)').text();
            if (attributeLabel.find('.selected-color').length <= 0) {
                attributeLabel.append(`<span class="selected-color">${attributeValue}</span>`);
            } else {
                attributeLabel.find('.selected-color').text(attributeValue);
            }

            const lastItems = attributeLabel.find('.message-last-items');
            if (nodeSelected.hasClass('lastItems')) {
                const lastItemsMessage = nodeSelected.find('.tooltip.message-last-items').text();
                if (lastItems.length <= 0) {
                    attributeLabel.append(`<span class="message-last-items">${lastItemsMessage}</span>`);
                } else {
                    lastItems.text(lastItemsMessage);
                }
            } else {
                lastItems.remove();
            }
        }
    });
    ctaBarCheckSelectedOptions();
};

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', {
            url: selectedValueUrl,
            container: $productContainer,
        });

        $.ajax({
            url: selectedValueUrl,
            type: 'GET',
            dataType: 'json',
            success(data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                checkSelectedOption();

                if ($('.set-item').length) {
                    updateAddToCartButtonSet();
                } else {
                    updateAddToCartButton();
                }

                $('body').trigger('product:afterAttributeSelect', {
                    data,
                    container: $productContainer,
                });

                $.spinner().stop();
            },
            error() {
                $.spinner().stop();
            },
        });
    }
}

function checkCartGlobalButton() {
    let disable = true;
    if ($('.add-to-cart-global').length) {
        const listButtons = $('button.add-to-cart');
        // eslint-disable-next-line func-names
        listButtons.each(function () {
            if ($(this).hasClass('disabled')) {
                disable = false;
            }
        });
        if (!disable) {
            $('button.add-to-cart-global').addClass('disabled');
        } else {
            $('button.add-to-cart-global').removeClass('disabled');
        }
    }
}

function disableButtonFromCheck(pid, attri, disEvent, productDetail, span) {
    let disable = disEvent;
    if (
        !productDetail
            .find(`.attribute[data-pid=${pid}][data-attr=${attri}] select[class*='select-']`)
            .children('option:selected')
            .attr('data-attr-value')
        && !span
    ) {
        disable = false;
    }
    return disable;
}

function checkAddToCartButton(productDetail, disable, attr) {
    const productDetailClone = productDetail.clone();
    let disEvent = disable;

    $('.select-attr-error').remove();

    if (disEvent) {
        // eslint-disable-next-line func-names
        productDetailClone.each(function () {
            const pid = $(this).attr('data-pid');
            const attri = $(this).find(`.attribute[data-attr=${attr}]`).attr('data-attr');
            if ($(this).find('select').length || $(this).find('span').length) {
                disEvent = disableButtonFromCheck(pid, attri, disEvent, productDetail, $(this).find('span').hasClass('selected'));
            }
        });
    }

    if (!disEvent) {
        productDetail.find('button.add-to-cart').addClass('disabled');
    } else {
        productDetail.find('button.add-to-cart').removeClass('disabled');
    }

    checkCartGlobalButton();
}

const availability = () => {
    // eslint-disable-next-line func-names
    $(document).on('change', '.quantity', function (e) {
        e.preventDefault();

        let $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this)
                .closest('.modal-content')
                .find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            attributeSelect(
                $(e.currentTarget)
                    .find('option:selected')
                    .attr('data-url'),
                $productContainer,
            );
        }
    });
};

const ratingsLink = () => {
    $(document.body).on('click', '#reviews-container-anchor', (e) => {
        e.preventDefault();
        scrollAnimate($('#reviews-container'), 100);
    });
};

module.exports = {
    ...baseUtils,
    addToCart,
    getPidValue,
    descriptionBlock,
    availability,
    attributeSelect,
    getQuantitySelector,
    checkAddToCartButton,
    checkSelectedOption,
    ratingsLink,
    imageZoom: imageZoom,
};
